function showContent(index) {
    const contentBox = document.getElementById('text-content-' + index);
    const textTitle = document.getElementById('text-title-' + index);

    if(contentBox.classList.contains('show-content')) {
        contentBox.classList.remove('show-content')
    } else {
        contentBox.classList.add('show-content')
    }

    if(textTitle.classList.contains('show-title')) {
        textTitle.classList.remove('show-title')
    } else {
        textTitle.classList.add('show-title')
    }
}

function showTabContent(index) {
    const titleBox = document.getElementById('tab-title-box');
    var titleList = titleBox.children;
    // 遍历子元素
    for (var i = 0; i < titleList.length; i++) {
        var child = titleList[i];
        
        // 判断子元素是否包含类名为'active-title'
        if (child.classList.contains('active-title')) {
            // 如果包含类名'active-title'，则移除该类名
            child.classList.remove('active-title');
        }
        
        // 为点击的元素添加类名'active-title'
        if (child.id === 'tab-title-' + index) {
            child.classList.add('active-title');
        }
    }

    
    const contentBox = document.getElementById('tab-content-box');
    var contentList = contentBox.children;
    // 遍历子元素
    for (var i = 0; i < contentList.length; i++) {
        var child = contentList[i];
        
        // 判断子元素是否包含类名为'active-content'
        if (child.classList.contains('active-content')) {
            // 如果包含类名'active-content'，则移除该类名
            child.classList.remove('active-content');
        }
        
        // 为点击的元素添加类名'active-content'
        if (child.id === 'tab-content-' + index) {
            child.classList.add('active-content');
        }
    }
}